<template>
  <div class="common-box">
    <div>
      <el-form
        inline
        ref="form"
        class="search-form common-box-search-form"
        label-position="right"
        :model="form"
        label-width="70px"
      >
        <search-form @search="handleSearch" @refresh="handleRefresh">
          <div slot="content">
            <el-form-item label="合同编号：">
              <el-input
                size="mini"
                v-model.trim="form.contractNumber"
                placeholder="请输入合同编号"
                clearable
                @change="handleSearchListData"
              ></el-input>
            </el-form-item>
            <el-form-item label="项目名称：">
              <el-select
                size="mini"
                v-model="form.projectName"
                filterable
                placeholder="请选择项目名称"
                clearable
                reserve-keyword
                :remote="true"
                :remote-method="searchProjectList"
                @visible-change="searchProjectList('')"
                value-key="id"
                @change="handleSearchListData"
              >
                <el-option
                  v-for="item in projectList"
                  :key="item.id"
                  :label="item.projectName"
                  :value="item.projectName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="签约人：">
              <el-input
                size="mini"
                v-model.trim="form.signatory"
                placeholder="请输入签约人"
                clearable
                @change="handleSearchListData"
              ></el-input>
            </el-form-item>
            <el-form-item label="应收时间：">
              <el-date-picker
                v-model="receivableTime"
                size="mini"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                unlink-panels
                clearable
                @change="handleSearchListData"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="收款时间：">
              <el-date-picker
                v-model="receiptTime"
                size="mini"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                unlink-panels
                clearable
                @change="handleSearchListData"
              ></el-date-picker>
            </el-form-item>
          </div>
        </search-form>
      </el-form>
    </div>
    <div class="common-cover-div"></div>
    <div class="operation-and-table__container">
      <div class="btns__container">
        <el-button
          size="mini"
          type="primary"
          v-if="hasRole['HTYSKDC']"
          @click="exportContractCollection"
          class="plr28"
          >导出</el-button
        >
        <el-button
          size="mini"
          type="primary"
          @click="handleDelete"
          plain
          class="plr28"
          v-if="hasRole['HTYSKSC']"
          >删除</el-button
        >
        <el-checkbox v-model="statusFilterOver" @change="handleSearchListData">超期应收</el-checkbox>
        <el-checkbox v-model="statusFilterMonth" @change="handleSearchListData">30天内应收</el-checkbox>
      </div>
      <div class="table__container">
        <el-table
          v-loading="tableLoading"
          :data="list"
          height="100%"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
          @sort-change="handleSortChange"
          class="table-sortable-reset-header-padding"
        >
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="contractNumber"
            label="合同编号"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="projectName"
            label="项目名称"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            align="right"
            header-align="right"
            prop="receivableAmount"
            label="应收金额"
            width="150"
          >
            <template slot-scope="scope">{{
              scope.row.receivableAmount | separator
            }}</template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="receivableTime"
            label="应收时间"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            align="right"
            header-align="right"
            prop="receiptAmount"
            label="已收金额"
            width="150"
          >
            <template slot-scope="scope">{{
              scope.row.receiptAmount | separator
            }}</template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="receiptTime"
            label="收款时间"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            align="right"
            header-align="right"
            prop="notReceiptAmount"
            label="未收金额"
            width="150"
          >
            <template slot-scope="scope">{{
              scope.row.notReceiptAmount | separator
            }}</template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="overdueDays"
            label="逾期天数"
            width="100"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="receiveStatus"
            label="应收状态"
            width="100"
          ></el-table-column>
          <el-table-column label=" " prop=" "></el-table-column>
          <el-table-column label="操作" width="98px" fixed="right">
            <template slot-scope="scope">
              <el-button
                size="mini"
                v-if="hasRole['HTYSKSK']"
                type="text"
                @click="handleCheck(scope.row)"
                >收款</el-button
              >
              <div class="btn-divide" v-if="hasRole['HTYSKSK']"></div>
              <el-button
                size="mini"
                v-if="hasRole['HTYSKSC']"
                type="text"
                @click="deleteContractReceivable(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <check-dialog
      v-if="showDetail"
      :editData="detailData"
      @cancel="showDetail = false"
      @confirm="showDetail = false"
    ></check-dialog>
  </div>
</template>

<script>
import {
  getPageList,
  exportContractCollection,
  removeEmployeeCollection,
} from "@/api/ContractReceivables";
import checkDialog from "./components/checkDialog.vue";
import { getProjectSimpleList } from "@/api/MaintenanceWorkOrder";
export default {
  name: "ContractReceivables",
  components: {
    checkDialog,
  },
  data() {
    return {
      showDetail: false,
      detailData: {},
      form: {
        contractNumber: null,
        projectName: null,
        receiptTimeEnd: null,
        receiptTimeStart: null,
        receivableTimeEnd: null,
        receivableTimeStart: null,
        signatory: null,
      },
      tableLoading: false,
      list: [],
      multipleSelection: [],
      pageIndex: 1,
      pageSize: 50,
      total: 0,
      projectList: [],
      receivableTime: [],
      receiptTime: [],
      statusFilterMonth: false,
      statusFilterOver: false
    };
  },
  computed: {
    hasRole: function () {
      return this.$store.getters["common/promise/getRole"](this.$route.path);
    },
  },
  created() {
    this.getListData();
  },
  methods: {
    async searchProjectList(keyword) {
      const res = await getProjectSimpleList({
        keyword: keyword,
        size: 100,
      });
      if (res.code === 200) {
        this.projectList = res.data;
      }
    },
    handleSearch() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleRefresh() {
      this.pageIndex = 1;
      for (let key in this.form) {
        if (Array.isArray(this.form[key])) {
          this.form[key] = [];
        } else {
          this.form[key] = "";
        }
      }
      this.receivableTime = [];
      this.receiptTime = [];
      this.getListData();
    },
    handleSearchListData() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCheck(row) {
      this.detailData = row;
      this.detailData.resourceType = String(this.detailData.resourceType);
      this.showDetail = true;
    },
    async handleDelete() {
      if (!this.multipleSelection.length) {
        this.$message.warning("请选择要删除的行");
        return;
      }
      let idList = this.multipleSelection.map((item) => item.id);
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await removeEmployeeCollection({ idList });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteContractReceivable(row) {
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await removeEmployeeCollection({ idList: [row.id] });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getListData();
    },
    async getListData() {
      this.tableLoading = true;

      if (this.receiptTime && this.receiptTime.length) {
        this.form.receiptTimeStart = this.receiptTime[0];
        this.form.receiptTimeEnd = this.receiptTime[1];
      } else {
        this.form.receiptTimeStart = ""
        this.form.receiptTimeEnd = ""
      }
      if (this.receivableTime && this.receivableTime.length) {
        this.form.receivableTimeStart = this.receivableTime[0];
        this.form.receivableTimeEnd = this.receivableTime[1];
      } else {
        this.form.receivableTimeStart = ""
        this.form.receivableTimeEnd = ""
      }
      const params = await this.getParams();
      const res = await getPageList(params);
      if (res.code === 200) {
        this.list = [...res.data.list];
        this.total = res.data.total;
      }
      this.tableLoading = false;
    },
    confirm() {
      this.showAdd = false;
      this.showEdit = false;
      this.pageIndex = 1;
      this.getListData();
    },
    getParams() {
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let key in this.form) {
        if (this.form[key]) params[key] = this.form[key];
      }
      if (this.statusFilterOver) {
        params.statusFilterOver = 1
      } else {
        params.statusFilterOver = 0
      }
      if (this.statusFilterMonth) {
        params.statusFilterMonth = 1
      } else {
        params.statusFilterMonth = 0
      }
      return params;
    },
    async exportContractCollection() {
      const params = await this.getParams();
      exportContractCollection(params);
    },
    // 列表排序
    handleSortChange({ column, prop, order }) {
      if (order === "ascending") {
        this.form.sortOrder = "asc";
        this.form.sortField = prop;
      } else if (order === "descending") {
        this.form.sortOrder = "desc";
        this.form.sortField = prop;
      } else {
        this.form.sortField = "";
        this.form.sortOrder = "";
      }
      this.getListData();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/ContractReceivables/ContractReceivables.vue